var predefinedDeliveryOptions = {
    isPredefinedAddressSelected: false
}
var predefinedDeliveryMethod;
var changePredefinedDelivery;
var CheckoutPredefinedAddressJs = (function ($) {

    var $radioButtons;
    var $clickElem;

    var initShowHidePredefined = function (radioButtonsSel) {
        var radioBSel = radioButtonsSel + " input[type='radio']";
        showHidePredefinedDelivery($(radioBSel + '[name=deliveryMethod]:checked'));
        $(radioBSel).on("click", function () {
            showHidePredefinedDelivery($(this));
        });
    };

    var showHidePredefinedDelivery = function(target) {
        if (target.attr("value") === predefinedDeliveryMethod){
            if(hasContent('.j-predefined-first-name')) {
                $(".j-predefined-delivery-details").show();
            }else{
                 target.prop("checked", false);
            }
        }else{
            $(".j-predefined-delivery-details").hide();
        }
    }
    var hasContent = function(sel){
        return $(sel).html().trim();
    };
    var hidePredefinedAddressInfo = function () {
        var isContent = $radioButtons ? hasContent('.j-predefined-first-name') : false;
        if(!isContent) {
            $(".j-predefined-delivery-details").hide();
             if (typeof defaultDeliveryMethod !== 'undefined') {
                $radioButtons.filter("[value='"+defaultDeliveryMethod+"']").first().prop("checked", true).trigger("click");
             }
        }
    };
    var openPredefinedAddressesSelectionPopup = function (url) {
        $.ajax({
            url: url,
            type: "GET",
            cache: false,
            success: function (data) {
                $.fancybox({
                    width: 500, height: 300,
                    content: data,
                    fitToView: true,
                    autoSize: false,
                    afterClose: onClosePredefinedAddressPopup,
                    helpers: {
                        overlay: {
                            locked: false
                        }
                    }
                });
            }
        });
    };

    var selectPredefinedAddressSelectionPopup = function (address) {

        $(document).on('click', address, function () {
            var $clickElem = $(this);
            var addressCode = $clickElem.data("delivery");
            var url = $clickElem.data("confirmation-url");
            onConfirmationPredefinedAddress($clickElem);
            onClosePredefinedAddressPopup();

            $.ajax({
                url: url,
                type: "POST",
                cache: false,
                data: {addressCode: addressCode},
                success: function (data) {
                    jQuery.fancybox.close();
                }
            });

            if ($radioButtons === undefined) {
                var token = $("input[name='_csrf']").val();
                var header = "X-CSRF-TOKEN";
                $.ajax({
                    url: "/checkout/delivery/update",
                    data: {addressCode: addressCode},
                    beforeSend: function(xhr) {
                        xhr.setRequestHeader(header, token);
                    },
                    type: "POST",
                    cache: false,
                    success: function (data) {
                        $('#shippingAddressSummary').replaceWith(data);
                    }
                })
            }
        });
    }

    var addClickHandlerChangePredefinedAddress = function (changeElement) {

        $(document).on("click", changeElement, function (event) {
            event.preventDefault();
            $clickElem = $(changeElement);
            openPredefinedAddressesSelectionPopup($(changePredefinedDelivery).data("action"));
        });
    };

    var addClickHandlerPredefinedRadioButton = function (radioButtonSel) {
        $radioButtons = $(radioButtonSel);
        $(changePredefinedDelivery).on("click", function () {
            $clickElem = $(this);
            if (!hasContent('.j-predefined-first-name')) {
                openPredefinedAddressesSelectionPopup($clickElem.data("action"));
            }
        });
    };

    var onClosePredefinedAddressPopup = function () {
        if (predefinedDeliveryOptions.isSelectedPredefinedAddress === true) {
            $clickElem.data("selected", true);
            $clickElem.prop("checked", true);
            if ($radioButtons) {
                fillPredefinedAddressInfo();
            }
        } else {
            hidePredefinedAddressInfo();
        }
    };

    var fillPredefinedAddressInfo = function () {
        $('#checkbox-deliver-predefined-addresses').data("selected", true);
        $('.j-predefined-first-name').text(predefinedDeliveryOptions.firstName);
        $('.j-predefined-last-name').text(predefinedDeliveryOptions.lastName);
        $('.j-predefined-street-name').text(predefinedDeliveryOptions.street);
        $('.j-predefined-city-name').text(predefinedDeliveryOptions.city);
        $('.j-predefined-delivery-details').show();
    };

    var onConfirmationPredefinedAddress = function (predefinedDeliveryAddress) {
        predefinedDeliveryOptions.isSelectedPredefinedAddress = true;

        predefinedDeliveryOptions.firstName = predefinedDeliveryAddress.find(".j-predefined-delivery-first-name-info").val();
        predefinedDeliveryOptions.lastName = predefinedDeliveryAddress.find(".j-predefined-delivery-last-name-info").val();
        predefinedDeliveryOptions.street = predefinedDeliveryAddress.find(".j-predefined-delivery-street-info").val();
        predefinedDeliveryOptions.city = predefinedDeliveryAddress.find(".j-predefined-delivery-city-info").val();
    };

    return {
        initShowHidePredefined: initShowHidePredefined,
        showHidePredefinedDelivery: showHidePredefinedDelivery,
        addClickHandlerPredefinedRadioButton: addClickHandlerPredefinedRadioButton,
        addClickHandlerChangePredefinedAddress: addClickHandlerChangePredefinedAddress,
        selectPredefinedAddressSelectionPopup: selectPredefinedAddressSelectionPopup
    }
})(jQuery);

$(document).ready(function () {
    var isRadioButton = typeof $("#predefinedRadioButton") !== 'undefined' && typeof $("#predefinedRadioButton").val() !== 'undefined';
    var isChangeDeliveryButton = typeof $("#predefinedChangeButton") !== 'undefined' && typeof $("#predefinedChangeButton").val() !== 'undefined';

    if (isRadioButton || isChangeDeliveryButton) {
        changePredefinedDelivery = isRadioButton ? "#predefinedRadioButton" : ".j-change-predefined";

        predefinedDeliveryMethod = $(changePredefinedDelivery).val();
        var radioButtonsSel;
        if (isRadioButton) {
            CheckoutPredefinedAddressJs.initShowHidePredefined(".j-delivery-method-radio-buttons");
            radioButtonsSel = ".j-delivery-method-radio-buttons input[type='radio']";
            CheckoutPredefinedAddressJs.addClickHandlerPredefinedRadioButton(radioButtonsSel);
        }

        CheckoutPredefinedAddressJs.addClickHandlerChangePredefinedAddress(".j-change-predefined");

        var predefinedAddress = ".j-predefined-delivery-address";
        CheckoutPredefinedAddressJs.selectPredefinedAddressSelectionPopup(predefinedAddress);
    }
});
